import { useState } from "react";
import { Link } from "react-router";
import styled from "styled-components";

import Card from "./Card";
import useRevitValues from "./useRevitValues";
import { useParameters } from "../../../../modules/shared-entities";
import { Bone, FluidAccent } from "../../../../modules/ui-kit";
import Button from "../../components/Button";

const Card2 = styled(Card)`
    --color-fluid: #77a7ff;

    ${ FluidAccent }
`;

const StyledList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
    list-style: none;
    margin: 0;
    padding: 0;
`;

const StyledEmptyState = styled.div`
    cursor: default;
    font-family: var(--font-mono), monospace;
    font-size: 1.6rem;
    max-width: 640px;
    padding: 48px 12px;

    a {
        color: #fff;
        &:hover {
            opacity: .6;
        }
    }
`;

const StyledButton = styled(Button)`
    margin: 12px;
`;

export default function List(props) {
    const { bimClassID, parameterID } = props;

    const revitValues = useRevitValues();

    const parameters = useParameters();

    const [all, setAll] = useState(false);

    if (revitValues.loading) return <Skeleton />;
    if (parameters.loading) return <Skeleton />;

    if (!revitValues.data) return undefined;

    const items = revitValues
        .data
        .revitValues
        .filter(
            (revitValue) => [
                parameterID ? (parameterID === revitValue.parameterID) : true,
                bimClassID ? (bimClassID === revitValue.bimClassID) : true,
            ].every(Boolean)
        )
        .map(
            (revitValue) => JSON.stringify(
                [
                    revitValue.parameterID,
                    revitValue.bimClassID ?? null,
                ]
            )
        )
        .filter(
            (e, i, a) => a.indexOf(e) === i
        )
        .map(
            (e) => JSON.parse(e)
        );

    function to(parameterID, bimClassID) {
        let url = `.`;

        if (parameterID) url += `/${ parameterID }`;
        if (bimClassID) url += `/${ bimClassID }`;

        return url;
    }

    if (!items.length) {
        return (
            <StyledEmptyState>
                <span>
                    your selection does not have any mapping set up
                    {
                        parameterID && (
                            <>
                                , you may <Link to={ to(parameterID, bimClassID) }>configure</Link> some
                            </>
                        )
                    }
                </span>
            </StyledEmptyState>
        );
    }

    return (
        <div>
            <StyledList>
                {
                    items.slice(0, all ? Number.MAX_SAFE_INTEGER : 50).map(
                        ([parameterID, bimClassID]) => (
                            <li key={ parameterID + bimClassID }>
                                <Link
                                    style={ { textDecoration: "none" } }
                                    to={ to(parameterID, bimClassID) }
                                >
                                    <Card2
                                        bimClassID={ bimClassID }
                                        onClick={ () => {} }
                                        parameterID={ parameterID }
                                    />
                                </Link>
                            </li>
                        )
                    )
                }
            </StyledList>
            {
                !all && items.length > 50 && (
                    <StyledButton onClick={ () => setAll(true) }>
                        load all
                    </StyledButton>
                )
            }
        </div>
    );
}

function Skeleton() {
    return (
        <StyledList>
            <li style={ { display: "flex", flexDirection: "column", gap: "4px" } }>
                <Bone height="2rem" width="30%" />
                <Bone height="1rem" width="20%" />
            </li>
            <li style={ { display: "flex", flexDirection: "column", gap: "4px" } }>
                <Bone height="2rem" width="22%" />
                <Bone height="1rem" width="26%" />
            </li>
            <li style={ { display: "flex", flexDirection: "column", gap: "4px" } }>
                <Bone height="2rem" width="18%" />
                <Bone height="1rem" width="16%" />
            </li>
            <li style={ { display: "flex", flexDirection: "column", gap: "4px" } }>
                <Bone height="2rem" width="28%" />
                <Bone height="1rem" width="21%" />
            </li>
        </StyledList>
    );
}
